import FJUtil from '../../util/FJUtil';
import FJMessageStore from '../../store/FJMessageStore';
import FJLocalStore from '../../store/FJLocalStore';
import {
    setSlicePeopleImageInfoAction,
    setSliceClothesImageInfoAction,
    setSliceSelectedStyleAction,
} from '../slices/FJSliceClothesChanger';
import FJNetworkStore from '../../store/FJNetworkStore';
import FJActionModal from './FJActionModal';
import FJActionCommon from './FJActionCommon';
import { setSliceCreationListAction, setSliceTaskStatusAction } from '../slices/FJSliceCommon';
import FJConstant from '../../constants/FJConstant';
import FJImageStore from '../../store/FJImageStore';
import FJCompressedImageStore from '../../store/FJCompressedImageStore';
import FJAppConstant from '../../constants/FJAppConstant.js';
import FJClothesChangerConfig from '../../config/appConfig/FJClothesChangerConfig.js';
import { CLOTHES_CHANGER_STYLE_LIST } from '../../config/dataConfig/FJClothesChangerData';

let f_eventId = null;

// 找到是否是用了我们自己的资源，并返回对应的分类
const _findCategory = name => {
    const selectedCategory = CLOTHES_CHANGER_STYLE_LIST.find(categoryData => {
        return categoryData.list.findIndex(item => item.name === name) !== -1;
    });
    return selectedCategory ? selectedCategory.categoryName : null;
};

const _clothesChangerAction = options => {
    return async (dispatch, getState) => {
        const { peopleImageInfo, clothesImageInfo, selectedStyle } = options;
        let { creditNumber, freeNumCreation } = getState().common;

        // const currentTaskId = new Date().getTime();
        // let _startTime = new Date().getTime();
        const __errorAndClear = () => {
            dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
            dispatch(setSliceCreationListAction([]));
        };
        const __errorAndReLoad = () => {
            const creationList = getState().common.creationList;
            const reLoadList = creationList.map(i => ({
                ...i,
                isLoading: false,
                isReload: true,
            }));
            dispatch(setSliceCreationListAction(reLoadList));
            dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
        };
        //1.判断是否上传图片
        if (!peopleImageInfo.src || !clothesImageInfo.src) {
            FJMessageStore.addMessage(FJLocalStore._('please-upload-a-photo-or-clothes-image-first'), 'error');
            return;
        }
        //2.开始状态修改
        const placeHolderList = FJUtil.createPlaceHolderList({
            count: 1,
            uploadImageInfo: peopleImageInfo,
            generateInfo: {
                peopleImageInfo,
                clothesImageInfo,
                selectedStyle,
            },
        });
        dispatch(setSliceCreationListAction(placeHolderList));
        dispatch(setSliceTaskStatusAction(FJConstant.START));

        //3.判断登陆
        const userSpaceType = await FJUtil.checkUserSpace();
        if (userSpaceType > 0) {
            dispatch(FJActionCommon.userSpaceChangeAction(userSpaceType));
            __errorAndClear();
            return;
        }
        //4.额度判断
        if (creditNumber < FJClothesChangerConfig.unitPrice && !freeNumCreation) {
            dispatch(FJActionModal.showUpgradeModalAction());
            __errorAndClear();
            return;
        }
        const isFree = creditNumber < FJClothesChangerConfig.unitPrice && freeNumCreation;

        try {
            //5.上传s3
            const urls = [peopleImageInfo.src, clothesImageInfo.src];
            const imageS3UrlList = await FJImageStore.uploadFilesByUrl(urls);
            if (!imageS3UrlList || getState().common.appType !== FJAppConstant.CLOTHES_CHANGER) {
                __errorAndClear();
                return;
            }

            const __request = async () => {
                return await FJNetworkStore.clothesChanger({
                    image: imageS3UrlList[0],
                    garment: imageS3UrlList[1],
                });
            };
            //6.创建任务
            f_eventId = await FJActionCommon.createRequestTask(__request, dispatch);
            const tool = FJUtil.getToolName();
            FJUtil.eaLog('ai tool start generating', { 'credit&free': isFree ? 'free' : 'credit', tool });
            //7.轮询任务状态
            const __callback = data => {
                const { type } = data;
                // const { type, waitingEndTime } = data;
                // let _endTime = new Date().getTime();
                // const queuingDuration = FJUtil.getTimeDiff(_startTime, waitingEndTime);
                // const generatingDuration = FJUtil.getTimeDiff(waitingEndTime, _endTime);
                // queuingDuration && (buryData['queuing duration'] = queuingDuration);
                // generatingDuration && (buryData['generating duration'] = generatingDuration);
                if (type === FJConstant.ERROR) {
                    // FJUtil.eaLog('photo restoration & colorizer generate fail', buryData);
                    __errorAndReLoad();
                } else if (type === FJConstant.SUCCESS) {
                    FJUtil.eaLog('ai tool generate success', {
                        tool: FJUtil.getToolName(),
                        'credit&free': isFree ? 'free' : 'credit',
                    });

                    try {
                        const category = _findCategory(selectedStyle);
                        const logData = {
                            page: window.isEditPage ? 'editor' : 'tools page',
                        };
                        if (category) {
                            logData.category = category;
                            logData['preset name'] = selectedStyle;
                        }
                        FJUtil.eaLog('clothes changer generate success', logData);
                    } catch (e) {
                        console.log(e);
                    }
                }
            };
            dispatch(
                FJActionCommon.pollingTaskAction([f_eventId], {
                    callback: __callback,
                }),
            );
        } catch (e) {
            __errorAndReLoad();
        }
    };
};

const FJActionClothesChanger = {
    resetAction: function () {
        return dispatch => {
            dispatch(setSliceClothesImageInfoAction({}));
            dispatch(setSlicePeopleImageInfoAction({}));
        };
    },
    uploadImageAction: function (file, isClothesImage = false, clearSelectStyle = true) {
        return async dispatch => {
            const isImage = FJUtil.isImage(file);
            if (!isImage) {
                FJMessageStore.addMessage(
                    FJLocalStore._('unsupported-format-please-try-again-with-supported-formats'),
                    'error',
                );
            } else {
                const data = await FJCompressedImageStore.compressImageByFile(file);
                if (data) {
                    isClothesImage
                        ? dispatch(setSliceClothesImageInfoAction(data))
                        : dispatch(setSlicePeopleImageInfoAction(data));
                    if (isClothesImage && clearSelectStyle) {
                        dispatch(setSliceSelectedStyleAction(''));
                    }
                } else {
                    FJMessageStore.addMessage(
                        FJLocalStore._('unsupported-format-please-try-again-with-supported-formats'),
                        'error',
                    );
                }
            }
        };
    },
    uploadImageUrlAction: function (url, options = {}) {
        return dispatch => {
            const { size, name, id, isClothesImage } = options;
            const info = {
                name: name,
                src: url,
                width: size.width,
                height: size.height,
                id: id,
            };
            isClothesImage
                ? dispatch(setSliceClothesImageInfoAction(info))
                : dispatch(setSlicePeopleImageInfoAction(info));
            if (isClothesImage) {
                dispatch(setSliceSelectedStyleAction(''));
            }
        };
    },

    // 选中由我们提供的服装
    selectClothesAction: function (name, imgSrc, applyDoneCallback) {
        return async (dispatch, getState) => {
            dispatch(setSliceSelectedStyleAction(name));
            const blob = await FJUtil.getBlobByUrl(imgSrc);
            if (!blob) {
                if (applyDoneCallback) applyDoneCallback();
                FJMessageStore.addMessage(FJLocalStore._('network-error-please-try-again'), 'error');
                return;
            }
            if (applyDoneCallback) applyDoneCallback();
            if (getState().clothesChanger.selectedStyle !== name) return;
            const file = new File([blob], 'image.png', { type: 'image/png' });
            dispatch(FJActionClothesChanger.uploadImageAction(file, true, false));
        };
    },

    generateAction: function () {
        return async (dispatch, getState) => {
            const { peopleImageInfo, clothesImageInfo, selectedStyle } = getState().clothesChanger;
            const data = {
                peopleImageInfo,
                clothesImageInfo,
                selectedStyle,
            };

            FJUtil.eaLog('clothes changer generate click');

            dispatch(_clothesChangerAction(data));
        };
    },

    cancelTaskAction: function () {
        return async dispatch => {
            try {
                f_eventId && (await FJNetworkStore.cancelTask(f_eventId));
            } catch (e) {
                FJMessageStore.addMessage(FJLocalStore._('cancel-to-delete-please-try-again'), 'error');
            } finally {
                dispatch(setSliceCreationListAction([]));
                dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
            }
        };
    },
    reGenerateAction: function (id) {
        return async (dispatch, getState) => {
            const { creationList } = getState().common;
            const item = creationList.find(item => item.id === id);
            const data = item.generateInfo;
            dispatch(_clothesChangerAction(data));
        };
    },

    initClothesImageAction: function () {
        return async dispatch => {
            if (window.isEditPage) return;
            const recId = FJUtil.getQueryString(FJConstant.REC_ID);
            const recIdInfo = recId ? JSON.parse(window.localStorage.getItem(recId)) : null;
            if (recIdInfo) {
                window.localStorage.removeItem(recId);
                const { url, width, height, id, name } = recIdInfo;
                if (url) {
                    dispatch(
                        FJActionClothesChanger.uploadImageUrlAction(url, {
                            size: { width, height },
                            id,
                            name,
                            isClothesImage: true,
                        }),
                    );
                }
            }
        };
    },
};
export default FJActionClothesChanger;
